import React ,{Component} from 'react'
import './Category-item.css'
import classnames from 'classnames';
import CategoryItemIcon from "./Category-item-icon/CategoryItemIcon";
import {connect} from 'react-redux';
import { getTranslate } from 'react-localize-redux';

class CategoryItem extends Component{
    render(){
        const {name,carType,carId,selectedCar,onClick,translate}=this.props
        return(
         <div
             className={classnames('category-item', {
                'category-item-selected-color category-item-selected ': carType === selectedCar,
             })} onClick={onClick.bind(this,name,carType,carId)}
              >
             <div><CategoryItemIcon iconName={carType} width={95}/></div>
               <span className={classnames('category-item-type', { 'category-item-type-selected': carType === selectedCar,})}>{translate(carType)}</span>
         </div>
        )
    }
}
const mapStateToProps = state => ({
    translate: getTranslate(state.locale),
});
export default connect(mapStateToProps)(CategoryItem)


// WEBPACK FOOTER //
// ./src/components/Calculator-board/Category-item/Category-item.js